import React, { useEffect, useState } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import axios from 'axios';
import { toast } from 'react-toastify';
import Pen from '@/assets/media/SVGComponents/Pen';
import Trash from '@/assets/media/SVGComponents/Trash';
import { useNavigate } from 'react-router-dom';
import Modal from '@/components/Modal';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';
import BONavigationButton from '@/components/back-office/BONavigationButton';
const VatsList = () => {
	const [vats, setVats] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [vatId, setVatId] = useState(null);
	const navigate = useNavigate();
	const role = JSON.parse(localStorage.getItem('role'));

	useEffect(() => {
		if (role && role !== 'super-admin') {
			toast.info('Zone interdite', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			navigate('/back-office');

			return;
		}
	}, [role]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/back-office/settings/vats/list`);

				if (response.status === 200) {
					setVats(response.data);
				}
			} catch (error) {
				console.error('Error fetching VATs:', error);
				toast.error('Une erreur est survenue', {
					position: 'top-center',
					autoClose: 3500,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
			}
		};

		fetchData();
	}, []);

	const handleOpenModal = (e, vatId) => {
		setShowModal(true);
		setVatId(vatId);
	};

	const handleModalSubmit = async () => {
		try {
			await axios.delete(`${import.meta.env.VITE_API_URL}/api/back-office/settings/vats/${vatId}/delete`);

			toast.success('TVA supprimée avec succès', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		} catch (error) {
			console.error('Error deleting vat:', error);
			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate(0);
		}, 1500);
	};

	return (
		<BOLayout>
			<div className="mb-4 grid grid-cols-1 gap-12">
				<SettingsTopBanner />
				<h1 className="text-3xl font-bold text-center">Liste des tva</h1>
				<BONavigationButton
					text={'Créer une TVA'}
					navigationRoute={`/back-office/settings/tva/creation`}
				/>
			</div>

			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			<table className="table table-striped table-bordered table-fixed w-full text-center">
				<thead className="border-b border-b-black pb-2 mb-4">
					<tr>
						<th>Nom</th>
						<th>Type de produits</th>
						<th>Taux en %</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{vats.map((vat) => (
						<tr key={vat.id}>
							<td>{vat.name}</td>
							<td>{vat.product_type}</td>
							<td>{vat.rate}</td>
							<td className="flex items-center justify-center gap-2">
								<button type="button" onClick={() => navigate(`/back-office/settings/tva/${vat.id}/edition`)}>
									<Pen color="#A2924A" width={40} height={40} />
								</button>

								<button type="button" className="m-2" onClick={(e) => handleOpenModal(e, vat?.id)}>
									<Trash color="#A2924A" width={40} height={40} />
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</BOLayout>
	);
};

export default VatsList;
